class Region {
    constructor() {}
    getMidPosition() { throw new Error('not implemented'); }
    isPointInside(position) { throw new Error('not implemented'); }
}

export default Region;
